import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import variables from '@vab/styles/variables/variables.module.scss';
import { isExternal } from '@/utils/validate';
import { translate } from '@/i18n';
import { useRoutesStore } from '@/store/modules/routes';
import { defaultOpeneds, openFirstMenu, uniqueOpened } from '@/config';
import { useSettingsStore } from '@/store/modules/settings';

import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { nextTick, watchEffect } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const route = useRoute();
    const router = useRouter();
    const settingsStore = useSettingsStore();
    const {
      theme,
      collapse
    } = storeToRefs(settingsStore);
    const {
      foldSideBar,
      openSideBar
    } = settingsStore;
    const routesStore = useRoutesStore();
    const {
      getTab: tab,
      getTabMenu: tabMenu,
      getActiveMenu: activeMenu,
      getRoutes: routes,
      getPartialRoutes: partialRoutes
    } = storeToRefs(routesStore);
    const handleTabClick = () => {
      nextTick(() => {
        if (isExternal(tabMenu.value.path)) {
          window.open(tabMenu.value.path);
          setTimeout(() => {
            router.push(`/direct?path=/`);
          }, 500);
        } else if (openFirstMenu) router.push(tabMenu.value.redirect || tabMenu.value);
      });
    };
    watchEffect(() => {
      const foldUnfold = document.querySelector('.fold-unfold');
      if (theme.value.layout === 'column' && route.meta.noColumn) {
        foldSideBar();
        if (foldUnfold) foldUnfold.style = 'display:none';
      } else {
        openSideBar();
        if (foldUnfold) foldUnfold.style = '';
      }
    });
    const __returned__ = {
      route,
      router,
      settingsStore,
      theme,
      collapse,
      foldSideBar,
      openSideBar,
      routesStore,
      tab,
      tabMenu,
      activeMenu,
      routes,
      partialRoutes,
      handleTabClick,
      get variables() {
        return variables;
      },
      get translate() {
        return translate;
      },
      get defaultOpeneds() {
        return defaultOpeneds;
      },
      get uniqueOpened() {
        return uniqueOpened;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});